import { useState, useEffect, useMemo, useRef } from 'react'
import axios from 'axios'
import { useAdminURL } from '../contexts/Domain'

export interface UserEmailTemplate {
    SId: string
    subject: string
    body: string
    name: string
    locale?: string
}

interface UserEmailTemplateResponse {
    count: number
    userEmailTemplates: Array<UserEmailTemplate>
}

interface UseUserEmailTemplatesProps {
    page: number
    keywords: string
    onNewResults?: (response: any) => void
    onNextPageResults?: (response: any) => void
    onError?: (response: any) => void
}
export default function useUserEmailTemplates(props: UseUserEmailTemplatesProps) {
    const adminURL = useAdminURL()

    const [data, setData] = useState<UserEmailTemplateResponse>(null)
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState('')

    const fetchNewResults = (hasPageChanged?: boolean) => {
        setLoading(true)
        setError('')

        axios.get(`${adminURL}/action/myAccount/userEmailTemplate/list?page=${props.page}&keywords=${props.keywords || ''}`)
            .then(response => {
                setLoading(false)
                setData(response.data)
                if (hasPageChanged) {
                    if (typeof props.onNextPageResults === 'function') {
                        props.onNextPageResults(response.data)
                    }
                } else {
                    if (typeof props.onNewResults === 'function') {
                        props.onNewResults(response.data)
                    }
                }
            })
            .catch(err => {
                setError('An error occurred')
                if (typeof props.onError === 'function') {
                    props.onError(err)
                }
            })
    }

    const prevPage = usePrevious(props.page)

    useEffect(() => {
        const hasPageChanged = props.page !== prevPage

        fetchNewResults(hasPageChanged)
    }, [props.page, props.keywords])

    return useMemo(() => ({
        data,
        loading,
        error,
    }), [
        data,
        loading,
        error,
    ])
}

export function usePrevious(value: any): any {
    const ref = useRef();
    useEffect(() => {
      ref.current = value;
    });
    return ref.current;
  }
